import { AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery } from '@festina/unitlink-general-types/unitlink/hooks/AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery'

export const useFetchInvestedAccounts =
  AccountingOpenPostPostingsService_openPostPostingsServiceGetQuery.useSuspenseQuery
